import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/vercel/path0/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/SharedComponent/WhatsAppButton.tsx");
